import type { FC, Ref } from "react";
import { Gallery, type GalleryProps } from "@huub-web/ui";

export type GalleryTemplateProps = {
  images: GalleryProps["images"];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const GalleryTemplate: FC<GalleryTemplateProps> = ({ images, ref }) =>
  (images && images.length > 0 && <Gallery ref={ref} images={images} />) ??
  null;
